import React, {
  ReactElement, ReactNode, useEffect, useRef,
} from 'react';
import './styles.css';

interface Props {
  content: ReactNode;
  children?: ReactElement;
  isOpen: boolean;
  x?: number;
  y?: number;
  onClickOutside: () => void;
  className?: string;
  contentClassName?: string;
}

const Popover:React.FC<Props> = ({
  content, children, isOpen, x = 0, y = 0, onClickOutside, className = '',
  contentClassName = '',
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  /**
 * Hook that alerts clicks outside of the passed ref
 */
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        onClickOutside();
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <div className={`popover__wrapper ${className}`}>
      {children && children}
      {isOpen && (
      <div
        className={`popover__content rounded-xl ${isOpen ? 'popover-show' : ''} ${contentClassName}`}
        ref={wrapperRef}
        style={{
          transform: `translate(${x}px, ${y}px)`,
        }}
      >
        {content}
      </div>
      )}
    </div>
  );
};

export default Popover;
